import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
import { getAssetInAppShortUrl, getCmsFreeSignUpUrl } from '../utils/urls';
import { isQa } from '../utils/env';
// @ts-expect-error static asset
import cmsFreeImageUrl from 'bender-url!../../img/cms-free-signup.png';
// @ts-expect-error static asset
import cmsFreeImageUrl2x from 'bender-url!../../img/cms-free-signup-2x.png';
import MediaSection from './MediaSection';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CmsFreeSection({
  className,
  onTrackInteraction
}) {
  const isPrerender = getIsPrerenderUserAgent();
  return /*#__PURE__*/_jsx(MediaSection, {
    button: !isPrerender && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        href: getCmsFreeSignUpUrl({
          query: {
            intent: 'marketplaceTheme'
          },
          env: isQa() ? 'qa' : 'prod'
        }),
        onClick: () => onTrackInteraction('click cms free signup button'),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.cmsFree.signUpButtonText"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        href: getAssetInAppShortUrl(),
        onClick: () => onTrackInteraction('click cms free login button'),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.cmsFree.loginButtonText"
        })
      })]
    }),
    className: className,
    color: "light",
    "data-test-id": "cms-free-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.cmsFree.description"
    }),
    media: /*#__PURE__*/_jsx(UIImage, {
      src: cmsFreeImageUrl,
      srcSet: `${cmsFreeImageUrl2x} 2x`,
      style: {
        width: '100%',
        maxWidth: 500
      }
    }),
    orientation: "media-right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.cmsFree.title"
    })
  });
}